/**
 * Production-safe logging utility
 *
 * Debug and info logs are stripped from production builds.
 * Errors and warnings are always logged for monitoring.
 */

export const logger = {
  /**
   * Log errors - always kept in production for error monitoring
   */
  error: (...args) => {
    console.error('🔴', ...args);
  },

  /**
   * Log warnings - always kept in production
   */
  warn: (...args) => {
    console.warn('⚠️', ...args);
  },

  /**
   * Log info messages - only in development
   * Use for important but non-critical information
   */
  info: (...args) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('ℹ️', ...args);
    }
  },

  /**
   * Log debug messages - only in development
   * Use for detailed debugging information
   * These are completely stripped from production builds
   */
  debug: (...args) => {
    if (process.env.NODE_ENV === 'development') {
      console.debug('🔍', ...args);
    }
  },

  /**
   * Log success messages - only in development
   * Use for positive confirmations during development
   */
  success: (...args) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('✅', ...args);
    }
  }
};
